import React, { useEffect, useRef, useState  } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./Selfscroll.css";
import "./SelfResponsive.css";
import "./SelfOverlayVideoSection.css";

import "./SelfTab.css";
// import "normalize.css"
// ../assets/video/Book1.mp4
// import videoSrc from '../../assets/selfaudit/video/BOOK1.mp4'
import scope from "../../assets/selfaudit/images/scope.svg";
import scan from "../../assets/selfaudit/images/scan.svg";
import bulb from "../../assets/selfaudit/images/bulb.svg";

gsap.registerPlugin(ScrollTrigger);

const SelfScrollThroughHero = () => {
  const videoRef = useRef(null);
  const triggerRef = useRef(null);
  const hasPlayed = useRef(false); // Track if the video has already played
  const [isVisible, setIsVisible] = useState(false);


  const textRef = useRef();
    // Intersection Observer for fade-in text
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting); // Set visibility based on intersection
        },
        {
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );
  
      const textElement = textRef.current;
      if (textElement) observer.observe(textElement);
  
      return () => {
        if (textElement) observer.unobserve(textElement);
      };
    }, []);

  useEffect(() => {
    const video = videoRef.current;
    const trigger = triggerRef.current;

    if (!video || !trigger) return;

    const handleScrollTrigger = () => {
      ScrollTrigger.create({
        trigger: trigger, // Element that triggers the video play
        start: "top top", // When the text reaches the top of the screen
        onEnter: () => {
          if (!hasPlayed.current) {
            video.play(); // Play the video
            hasPlayed.current = true; // Mark as played
          }
        },
      });
    };

    if (video.readyState >= 2) {
      handleScrollTrigger();
    } else {
      video.addEventListener("loadedmetadata", handleScrollTrigger);
    }

    // Stop the video when it ends
    const handleVideoEnd = () => {
      video.pause();
      video.currentTime = 5; // Reset the video to the start
    };

    video.addEventListener("ended", handleVideoEnd);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      video.removeEventListener("loadedmetadata", handleScrollTrigger);
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, []);

  return (
    <section className="check_list">
      <div className="container">
        <div className="byb-checklist-header" ref={triggerRef}>
          <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
              >IN KIT – BRAND AUDIT TOOL</p>
          <h1>
            <span className="d-lg-block "> Insight is the Difference</span> Between
            Your Position and Potential.
          </h1>
        </div>

        <div
          className="scroll-through-hero st-hero-animate sth-fadein-off byb-toolkit"
        >
          <div className="scroll-through-hero-pin scroll_pin desktop_show">
            <div className="video-container" style={{ backgroundColor: 'transparent' }}>
              <video
                ref={videoRef}
                src="https://brewyourbrand.blr1.digitaloceanspaces.com/book1.webm"
                playsInline
                webkit-playsInline
                preload="metadata"
                muted
                className="video-background"
              />
            </div>
          </div>

          <img
            src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book1.svg"
            className="show_mob" width="720" height="720" loading="lazy" decoding="async"
            alt="Brand self-audit checklist mobile visual"
          />
          <p className="byb-checklist-belowimg-para">
            Audit everything from <span style={{color:"#fff"}}> identity to market position,</span> ensuring each
            aspect aligns with your vision and goals.
          </p>
          <div className="byb-checklist-para">
            <div className="para scope-para">
              <img src={scope} alt="Scope brand audit checklist icon" />
              <p>
              <span style={{color:"#fff"}}>Identify</span> opportunities to align more closely with your vision.
              </p>
            </div>
            <div className="para scan-para">
              <img src={scan} alt="Scan brand position checklist icon" />
              <p>
              <span style={{color:"#fff"}}> Understand</span> where you <span className="d-block">stand in the market.</span>
              </p>
            </div>
            <div className="para bulb-para">
              <img src={bulb} alt="Brand insight checklist icon" />
              <p><span style={{color:"#fff"}}>Gain</span> deep insights into your brand’s current state.</p>
            </div>
          </div>
        </div>
       
      </div>
    </section>
  );
};

export default SelfScrollThroughHero;
